<script >
    import RoundPlusIco from '../icons/round-plus.svelte'

    export let text
</script>

<style lang="scss">
    .input-file {
        height: 50px;
        padding-left: 50px;
        position: relative;
        background: #2C322F;
        border-radius: 30px;
        cursor: pointer;
        border: 1px dashed #DF4937;
        &:hover .text {
            text-decoration:none;
        }
        .ico {
            position: absolute;
            top: 14px;
            left: 21px;
        }
        .text {
            opacity: 0.7;
            font-family: Roboto;
            font-size: 15px;
            color: #FFFFFF;
            letter-spacing: 0.04px;
            margin-bottom: 15px;
            line-height: 50px;
            text-decoration: underline;
            color: #DF4937;
        }
    }
</style>

<div class="input-file" on:click>
    <div class="ico">
        <RoundPlusIco />
    </div>
    <div class="text">
        {text}
    </div>
</div>


